import React, { useState } from "react";
import { Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router";
import { activateMenu } from "redux/actions";
import { useAppDispatch } from "redux/store";
import { setNagarType } from "redux/actions";

type Props = {
    id:number;
    nagar_khanda_name: string;
    gramas_formed: number;
    samithi_formed :number;
    total_basti :number;
    nagar_type:number;
    total_gramas :number;
};
export const NagarKhandaReportCard: React.FC<Props> = ({ id, nagar_type,nagar_khanda_name,gramas_formed,samithi_formed,total_basti ,total_gramas }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const handleCardClick = (id,nagar_type) => {
        dispatch(setNagarType(nagar_type))
      localStorage.setItem("nagar_type", nagar_type);
    // console.log("22nagarKhNDA",nagar_type)
    localStorage.setItem('nagar_khanda_name',nagar_khanda_name)
        navigate('/upmandalbasthireports/'+id, { replace: true });
    }
    return (
        <Col md={4} xl={3} xs={6} className="cursor-pointer mb-4" onClick={() => { handleCardClick(id,nagar_type); }}>
                 <Card className=" shadow h-100 py-2.5"  style={{ borderLeft:( gramas_formed > 0 ||samithi_formed>0 )? '5px solid #194380' : '5px solid #FF0000' }}>            
                           <Card.Body style={{padding :"2rem"}}>

                    <div className="row no-gutters align-items-center">
                        <div className="col mr-2">
                        <div className="text-xl font-weight-bold  text-uppercase mb-1"style={{ color: (gramas_formed >0 ||samithi_formed > 0) ? '#194380' : '#FF0000' }}>
                                <p>{nagar_khanda_name}</p></div>
                            <div className=" mb-0 font-weight-bold text-gray-800"></div>
                        </div>
                        <div className=" mb-0.4 font-weight-bold text-gray-800">
                            {/* <i className="fas fa-clipboard-list fa-2x text-gray-300"></i> */}
                            {total_basti >0 &&
                            <p>{samithi_formed}  Over  / {total_basti}  Total  Basthis</p>
}
                        </div>
                        <div className=" mb-0 font-weight-bold text-gray-800">
                            {/* <i className="fas fa-clipboard-list fa-2x text-gray-300"></i> */}
                            {total_gramas >0 &&
                            <p>{gramas_formed} Over  /  {total_gramas} Total Villages</p>
}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

